<template>
<div class="opt-content-wrapper pay-pane active">
    <div class="text-center mt-3">
        <!--h1 style="color: grey; width: 100%;">{{ data.option }}</-h1-->
        <img v-if="item.image_url" :src="item.image_url" class="provider-logo" alt="" style="width: 20%; height :auto" />
        <h5 style="" class="mt-3 gray">Coming Soon</h5>
        <p class="mt-3" style="font-size:14px;"> <strong>{{ item.option}}</strong> is under development, please use other payment method.</p>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from './includes/bus.js';
/* eslint-disable */
export default {
    name: 'ComingSoon',
    props: ['data', 'client_info'],

    computed: {
        item() {
            return this.data.details;
        }
    },
    mounted() {
        // console.log(this.data);
        EventBus.$on('global-back', payload => {
            // console.log(payload);
            if (payload.in_view.toLowerCase() == 'comingsoon' && payload.action == "back") {
                this.changePaymentOption();
            }
        });
    },
    methods: {
        changePaymentOption() {
            this.$parent.changeComponent("PaymentOptions");
        },
    },
}
</script>
